import * as React from 'react';

export const TradeArea = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2H14V0H2V2ZM2 4L0 7.33333V9H1V15H10V11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5V15H15V9H16V7.33333L14 4H2ZM3 10H8V13H3V10Z"
      fill="#737A8E"
    />
  </svg>
);
